import { Outlet } from 'react-router-dom';
import { SidebarDrawer } from './SidebarDrawer';

// Persistent 280px sidebar + scrollable <Outlet/> content region (ports the NavHost.kt shell).
export function AppShell() {
  return (
    <div className="flex h-dvh w-full overflow-hidden bg-background text-foreground">
      <SidebarDrawer className="h-dvh w-[280px] shrink-0 overflow-hidden border-r bg-sidebar" />
      <main className="min-h-0 min-w-0 flex-1 overflow-y-auto overscroll-y-contain">
        <Outlet />
      </main>
    </div>
  );
}
